import { CREATE_BASKET, CREATE_BASKET_ERROR, CREATE_BASKET_SUCCESS } from "core-web/state/models/Basket/constants";

import { BasketEvents } from "core-web/libs/Events/constants";
import Cookies from "js-cookie";
import CreateBasket from "core-web/libs/GrebbCommerceAPI/Basket/CreateBasket";
import Events from "core-web/libs/Events";
import { acquireMutex } from "core-web/state";
import setBasketIdCookie from "core-web/state/models/Basket/utils/setBasketIdCookie";
import store from "core-web/state/store";
import tracking from "core-web/components/Tracking";

export const createBasket = () => async (dispatch, getState) => {
    const mutexLock = await acquireMutex("basket.getBasket");
    const eventId = tracking.getUniqueId();

    const { isFetching } = getState().basket;

    if (isFetching) {
        return;
    }

    // These are hardcoded for now. Should be read from state later.
    dispatch({ type: CREATE_BASKET });

    Cookies.remove("checkoutId");
    Cookies.remove("paymentReference");

    try {
        const response = await CreateBasket("127.0.0.1", eventId);

        if (!response?.data) {
            throw "Could not create basket";
        }

        setBasketIdCookie(response.data.id);

        dispatch({
            type: CREATE_BASKET_SUCCESS,
            basketId: response.data.id,
            currency: response.data.currency_id || null,
            info: response.data.info || [],
            customerId: response.data.customer_id || "",
        });

        Events.trigger(BasketEvents.CREATED);

        mutexLock();

        return response;
    } catch (e) {
        dispatch({ type: CREATE_BASKET_ERROR });

        mutexLock();

        throw e;
    }
};

export default () => store.dispatch(createBasket());
